import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class DropdownService {
  public descendantMenuItemClick$ = new Subject<unknown>();

  public onDescendantMenuItemClick(menu: unknown): void {
    this.descendantMenuItemClick$.next(menu);
  }
}
